import React from 'react';
import StaticTable from '../StaticTable/StaticTable';
import { TableWrapper } from '../StaticTable/StaticTable.style';

function VendorEliminationReport(props) {
	const { vendorElimationReportData } = props;
	return (
		<TableWrapper style={{ marginLeft: '5%' }}>
			<StaticTable
				data={vendorElimationReportData}
				width={'100%'}
				height={350}
			/>
		</TableWrapper>
	);
}

export default VendorEliminationReport;
